import React from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { CalculatorSection } from './payroll/CalculatorSection';
import { TaxTablesSection } from './payroll/TaxTablesSection';
import { TaxSetupSection } from './payroll/TaxSetupSection';
import { DeductionsSection } from './payroll/DeductionsSection';
import { ImportsSection } from './payroll/ImportsSection';
import { ComparisonSection } from './payroll/ComparisonSection';
import { GuidesSection } from './payroll/GuidesSection';

export default function PayrollNetPay() {
  return (
    <div className="space-y-6 p-1" data-testid="payroll-netpay-page">
      <div>
        <h1 className="text-2xl font-bold">Payroll Parallel Test — Net Pay</h1>
        <p className="text-sm text-slate-500">Gross-to-net using Finance-maintained, approved tax tables. Preview only — nothing posts to pay runs, the ledger, banking or NACHA.</p>
      </div>

      <Tabs defaultValue="calculator">
        <TabsList className="flex flex-wrap h-auto">
          <TabsTrigger value="calculator" data-testid="tab-calculator">Calculator</TabsTrigger>
          <TabsTrigger value="tables" data-testid="tab-tables">Tax tables</TabsTrigger>
          <TabsTrigger value="setup" data-testid="tab-setup">Tax setup</TabsTrigger>
          <TabsTrigger value="deductions" data-testid="tab-deductions">Deductions & garnishments</TabsTrigger>
          <TabsTrigger value="imports" data-testid="tab-imports">Imports</TabsTrigger>
          <TabsTrigger value="comparison" data-testid="tab-comparison">Comparison</TabsTrigger>
          <TabsTrigger value="guides" data-testid="tab-guides">Guides</TabsTrigger>
        </TabsList>
        <TabsContent value="calculator" className="mt-4"><CalculatorSection /></TabsContent>
        <TabsContent value="tables" className="mt-4"><TaxTablesSection /></TabsContent>
        <TabsContent value="setup" className="mt-4"><TaxSetupSection /></TabsContent>
        <TabsContent value="deductions" className="mt-4"><DeductionsSection /></TabsContent>
        <TabsContent value="imports" className="mt-4"><ImportsSection /></TabsContent>
        <TabsContent value="comparison" className="mt-4"><ComparisonSection /></TabsContent>
        <TabsContent value="guides" className="mt-4"><GuidesSection /></TabsContent>
      </Tabs>
    </div>
  );
}
